import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()(() => ({
  listItemContainer: {
    width: "100%",
    // maxHeight: "calc(100vh - 345px)",
    overflow: "scroll",
  },
}));

export default useStyle;
